/*
 * Tilt: native Shopify video slides in Motion 10.6.1 / PhotoSwipe 4.
 * Load after theme.js. The original gallery remains responsible for image
 * slides and variant ordering. No video sources are added before activation.
 */
(function () {
  'use strict';

  var theme = window.theme;
  if (!theme || !theme.Photoswipe || !theme.Product || !window.PhotoSwipe) return;

  var photoswipe = theme.Photoswipe.prototype;
  var product = theme.Product.prototype;
  if (photoswipe.tiltVideoLightbox || !product.playMp4Video) return;
  photoswipe.tiltVideoLightbox = true;

  var getImageData = photoswipe.getImageData;
  var initGallery = photoswipe.initGallery;
  var playMp4Video = product.playMp4Video;
  var activeContainer = null;

  // Motion synchronizes the underlying carousel on every PhotoSwipe change.
  // Keep that synchronization, but do not start a second player underneath it.
  product.playMp4Video = function () {
    if (activeContainer && this.container.contains(activeContainer)) return;
    return playMp4Video.apply(this, arguments);
  };

  photoswipe.getImageData = function () {
    return getImageData.apply(this, arguments).map(function (item) {
      var slide = item.el.closest('.product-main-slide');
      var source = slide && slide.querySelector('video.product__video, video.product-video-mp4-sound');
      if (!source || (!source.getAttribute('src') && !source.querySelector('source[src]'))) return item;

      var holder = document.createElement('div');
      holder.className = 'tilt-lightbox-video';
      item.tiltVideo = {
        source: source,
        width: Number(item.w),
        height: Number(item.h),
        holder: holder,
        player: null,
        time: 0,
        muted: source.defaultMuted || source.muted
      };
      // PhotoSwipe 4 treats items with html and no src as non-image slides.
      delete item.src;
      delete item.msrc;
      item.html = holder;
      item.w = 0;
      item.h = 0;
      return item;
    });
  };

  function releaseVideo(media) {
    var player = media.player;
    if (!player) return;
    media.time = Number.isFinite(player.currentTime) ? player.currentTime : 0;
    media.muted = player.muted;
    player.pause();
    player.removeAttribute('src');
    player.querySelectorAll('source').forEach(function (source) { source.remove(); });
    player.load();
    player.remove();
    media.player = null;
  }

  function activateVideo(media) {
    if (media.player) return;
    var source = media.source;
    var player = document.createElement('video');
    media.player = player;
    player.className = 'tilt-lightbox-video__player';
    player.controls = true;
    player.playsInline = true;
    player.preload = 'none';
    player.loop = source.loop;
    player.muted = media.muted;
    player.defaultMuted = media.muted;
    player.width = source.videoWidth || media.width;
    player.height = source.videoHeight || media.height;
    player.setAttribute('controlsList', 'nodownload');
    if (source.getAttribute('poster')) player.poster = source.getAttribute('poster');

    var title = source.closest('[data-section-type="product"]');
    title = title && title.querySelector('.product-single__title');
    if (title) player.setAttribute('aria-label', title.textContent.trim());

    // Let native controls handle seeking, volume and taps without PhotoSwipe
    // interpreting those gestures as dragging or closing the gallery.
    ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (eventName) {
      player.addEventListener(eventName, function (event) { event.stopPropagation(); });
    });
    player.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') event.stopPropagation();
    });
    if (media.time > 0) {
      player.addEventListener('loadedmetadata', function () {
        if (Number.isFinite(player.duration) && media.time < player.duration) {
          player.currentTime = media.time;
        }
      }, { once: true });
    }

    // Sources are attached only when this slide becomes current.
    if (source.getAttribute('src')) {
      player.src = source.getAttribute('src');
    } else {
      source.querySelectorAll('source[src]').forEach(function (entry) {
        player.appendChild(entry.cloneNode(false));
      });
    }
    media.holder.appendChild(player);
    if (player.muted) {
      var pending = player.play();
      if (pending) pending.catch(function () {
        // Autoplay can be refused; native play/controls remain available.
      });
    }
  }

  photoswipe.initGallery = function (items, index) {
    var videos = items.filter(function (item) { return item.tiltVideo; });
    if (!videos.length) return initGallery.apply(this, arguments);

    var owner = this;
    var container = this.container;
    var template = document.querySelector('.pswp');
    var closing = false;
    var current = null;
    var options = {
      allowPanToNext: false,
      captionEl: false,
      closeOnScroll: false,
      counterEl: false,
      history: false,
      index: index - 1,
      pinchToClose: false,
      preloaderEl: false,
      scaleMode: 'zoom',
      shareEl: false,
      tapToToggleControls: false,
      getThumbBoundsFn: function (itemIndex) {
        var item = items[itemIndex];
        // HTML slides have no image dimensions for the image zoom animation.
        if (item.tiltVideo) return;
        var rect = item.el.getBoundingClientRect();
        var scroll = window.pageYOffset || document.documentElement.scrollTop;
        return { x: rect.left, y: rect.top + scroll, w: rect.width };
      }
    };

    activeContainer = container;
    container.querySelectorAll('video.product__video').forEach(function (player) { player.pause(); });
    var gallery = this.gallery = new PhotoSwipe(template, PhotoSwipeUI_Default, items, options);

    gallery.listen('afterChange', function () {
      if (closing) return;
      owner.afterChange();
      var media = gallery.currItem.tiltVideo || null;
      template.classList.toggle('tilt-lightbox-video-active', !!media);
      if (media !== current) {
        if (current) releaseVideo(current);
        current = media;
        if (current) activateVideo(current);
      }
    });
    gallery.listen('close', function () {
      closing = true;
      videos.forEach(function (item) { releaseVideo(item.tiltVideo); });
    });
    gallery.listen('destroy', function () {
      videos.forEach(function (item) { releaseVideo(item.tiltVideo); });
      template.classList.remove('tilt-lightbox-video-active');
      activeContainer = null;
      // Resume the currently selected inline video only if its style is muted.
      var selected = container.querySelector('.product-main-slide.is-selected video.product__video');
      if (selected && (selected.defaultMuted || selected.muted)) {
        var pending = selected.play();
        if (pending) pending.catch(function () {
          selected.controls = true;
          var wrapper = selected.closest('.product__video-wrapper');
          if (wrapper) wrapper.setAttribute('data-video-style', 'unmuted');
        });
      }
      current = null;
    });

    gallery.init();
    this.preventiOS15Scrolling();
    // Motion's iOS helper registers resize per opening without removing it.
    // Remove the listener belonging to this session when it is destroyed.
    gallery.listen('destroy', function () {
      window.removeEventListener('resize', owner.syncHeight);
    });
  };
})();
